export const _ENDPOINT = {
  login: '/login',
  getUser: '/getUser',
  getAllUsers: '/getAllUsers',
  getAllGroups: '/getAllGroups',
  getGroupsForUser: '/getGroupsForUser',
  validationAddUser: '/validationAddUser',
  signUpUser: '/signUpUser',
  deleteUser: '/deleteUser',
  updateUserAttributes: '/updateUserAttributes',
  getAllCustomer: '/getAllCustomer',
  saveCustomer: '/saveCustomer',
  getCustomer: '/getCustomer',
  validationNewCustomer: '/validationNewCustomer',
  deleteCustomer: '/deleteCustomer',
  updateCustomer: '/updateCustomer',
  validationUpdateCustomer: '/validationUpdateCustomer',
  deleteAgreement: '/deleteAgreement',
  getAllAgreements: '/getAllAgreements',
  validationNewAgreement: '/validationNewAgreement',
  saveAgreement: '/saveAgreement',
  getTendinaAgreements: '/getTendinaAgreements',
  getAllCatalog: '/getAllCatalog',
  getTariffs: '/getTariffs',
  getHandsets: '/getHandsets',
  getBundledProductOffering: '/getBundledProductOffering',
  getAllInventory: '/getAllInventory',
  getProductRelationship: '/getProductRelationship',
  getTendineReporting: '/getTendineReporting',
  getReport: '/getReport',
  exportCsvOrderDetail: '/exportCsvOrderDetail',
  loginConfirmOtp: '/loginConfirmOtp',
  recuperaPassword: '/recuperaPassword',
  resetPassword: '/resetPassword',
};

export const _ENDPOINT_FWP = {
  getAllCatalog: '/WLGetCatalogList',
  getAllHistoryOrder: '/wlGetOrderHistory',
  getAllInventory: '/WLGetInventoryList',
  getInventoryDetailById: '/WLGetInventoryDetail',
  getFiltersInventory: '/WLGetInventoryFilters',
  GetUserBillingAccounts: '/WLGetUserCreationBillingAccounts',
  postOrder: '/WLPostOrder',
  exportCsvCatalog: '/WLExportCsvCatalog',
  exportCsvOrderHistory: '/WLExportCsvOrder',
  exportCsvInventory: '/WLExportCsvInventory',
  getCatalogDetailsLite: '/WLGetCatalogDetailLite',
  getAllHistoryFilter: '/WLGetOrderHistoryFilters',
  getHistoryDetails: '/WLGetOrderHistoryDetail',
  getCatalogFilters: '/WLCatalogFilters',
     getCatalogDetail: '/wlGetCatalogDetail',
  updateOrderDetails: '/WLManageOrder',
  updateInventory: '/WLUpdateInventory',
  exportMassiveUploadCatalogExcel: '/WLExportMassiveUploadExcel',
  MassiveUploadCatalog: '/massiveUploadCatalogLambdaHandler',
  MassiveUploadInventory: '/massiveUploadInventoryLambdaHandler',
  getCustomerdata: '/WLCustomerdata',
  getNotifications : '/wlGetNotifications', 
  updateNotifications : '/WlUpdateNotifications'
};
